AOS.init({
    once: false,
    startEvent: 'load',
    //disable: 'mobile',
    easing: 'ease'
});